import { camelize } from 'humps'
import { CategoryCounts } from '@/modules/accredited-establishments/api'
import { EstablishmentCategory } from '@/modules/accredited-establishments/api/types'

/**
 * Le no `categoryCounts` da listagem quantos resultados uma categoria tem.
 *
 * O interceptor de resposta cameliza as chaves do payload inteiro, inclusive as
 * de mapa, entao `EMERGENCY_UNITY` chega como `eMERGENCYUNITY`. Aplicar o mesmo
 * `camelize` na categoria reproduz a chave, em vez de fixar a forma deformada
 * aqui — se o interceptor mudar, isto acompanha.
 */
const getCategoryCount = (
  counts: CategoryCounts | undefined,
  category: EstablishmentCategory
): number | undefined => counts?.[camelize(category)]

export { getCategoryCount }
